// src/pages/AddSlotPage.jsx
import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/common/Layout';
import Card from '../components/common/Card';
import Button from '../components/common/Button';
import useAuth from '../hooks/useAuth';
import { useReservations } from '../hooks/useReservations';

const AddSlotPage = () => {
  // -------------------- state --------------------
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [availableSlots, setAvailableSlots] = useState(null);   // null = yükleniyor

  // -------------------- hooks --------------------
  const { user } = useAuth();                           // { uid, role, ... }
  const { addNewAvailableSlot, getAvailableTimeSlots } = useReservations();

  // -------------------- helpers --------------------
  const fetchSlots = useCallback(async () => {
    if (!date) return;
    try {
      const slotsDoc = await getAvailableTimeSlots(new Date(date)); // { id, slots:[] } veya null
      setAvailableSlots(slotsDoc?.slots ?? []);
    } catch (err) {
      console.error('Error fetching slots:', err);
    }
  }, [date, getAvailableTimeSlots]);

  // -------------------- effects --------------------
  useEffect(() => {
    fetchSlots();
  }, [fetchSlots]);

  // -------------------- form submit --------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addNewAvailableSlot(new Date(date), startTime, endTime);
      await fetchSlots();                             // listeyi güncelle
      setSuccessMessage('Slot eklendi!');
      setStartTime(''); setEndTime('');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      alert(err.message || 'Slot eklenirken hata oluştu.');
    }
  };

  // -------------------- yetki kontrolü --------------------
  if (!user || user.role !== 'admin') {
    return (
      <Layout>
        <p className="text-center text-red-500 mt-16">
          Bu sayfayı görüntüleme yetkiniz yok.
        </p>
      </Layout>
    );
  }

  // -------------------- render --------------------
  return (
    <Layout>
      <div className="max-w-5xl mx-auto">
        <Card title="Yeni Zaman Aralığı Ekle">
          {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
              {successMessage}
            </div>
          )}

          {/* ------ mevcut slotlar ------ */}
          {availableSlots === null ? (
            <p className="text-center mb-6">Slotlar yükleniyor…</p>
          ) : availableSlots.length === 0 ? (
            <p className="text-center mb-6">Seçili gün için slot yok.</p>
          ) : (
            <ul className="mb-6 space-y-1">
              {availableSlots.map((s, i) => (
                <li key={i} className="text-sm">
                  {s.startTime} – {s.endTime}
                </li>
              ))}
            </ul>
          )}

          {/* ------ form ------ */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="date" className="block text-sm font-medium">Tarih</label>
              <input
                type="date"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
                className="mt-1 block w-full border rounded-md px-3 py-2"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="startTime" className="block text-sm font-medium">Başlangıç</label>
                <input
                  type="time"
                  id="startTime"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  required
                  className="mt-1 block w-full border rounded-md px-3 py-2"
                />
              </div>
              <div>
                <label htmlFor="endTime" className="block text-sm font-medium">Bitiş</label>
                <input
                  type="time"
                  id="endTime"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  required
                  className="mt-1 block w-full border rounded-md px-3 py-2"
                />
              </div>
            </div>

            <div className="flex justify-end">
              <Button type="submit">Ekle</Button>
            </div>
          </form>
        </Card>
      </div>
    </Layout>
  );
};

export default AddSlotPage;
